

















import { Component, Prop } from "vue-property-decorator";
import DataTable from "@/shared/components/data-table.vue";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { mixins } from "vue-class-component";
import { ConsultoresService } from "@/services/consultores.service";
import { date, dateTime, timeFromNow } from "@/shared/filters";

@Component({
  components: {
    DataTable,
  },
  filters: { date, dateTime, timeFromNow },
})
export default class Tickets extends mixins(GlobalMixin) {
  @Prop() idConsultor!: number;
  promiseTickets: Promise<any[]> | null = null;
  loading = false;

  headersTickets = [
    { value: "DataCriacao", text: "Criado" },
    { value: "Tipo", text: "Tipo" },
    { value: "Assunto", text: "Assunto" },
    { value: "Status", text: "Status" },
    { value: "Analista", text: "Analista" },
  ];

  mounted() {
    this.fetchUltimosAcessos(this.idConsultor);
  }

  async fetchUltimosAcessos(idConsultor: number) {
    this.loading = true;
    try {
      const consultor = await ConsultoresService.ObterDadosConsultor(
        idConsultor
      );
      const retornoTickets = ConsultoresService.Tickets(consultor.email);
      if (!retornoTickets) {
        this.promiseTickets = retornoTickets;
      }
    } finally {
      this.loading = false;
    }
  }
}
